export const practiceAreas = [
  {
    id: 1,
    title: "Corporate Law",
    description: "Comprehensive corporate legal services including governance, restructuring, and regulatory compliance for domestic and international corporations.",
    icon: "Building2",
    details: "Our corporate law practice advises boards, management teams, and shareholders on complex transactions and corporate governance matters across multiple jurisdictions."
  },
  {
    id: 2,
    title: "Commercial Law",
    description: "Strategic commercial advice on complex transactions, joint ventures, and commercial agreements for businesses operating in the global marketplace.",
    icon: "Briefcase",
    details: "We provide pragmatic commercial legal solutions that protect our clients' interests while facilitating successful business outcomes."
  },
  {
    id: 3,
    title: "Cross-border M&A",
    description: "Expert guidance on international mergers, acquisitions, and corporate restructurings with deep knowledge of cross-jurisdictional complexities.",
    icon: "Globe",
    details: "Our cross-border M&A team has extensive experience managing multi-jurisdictional transactions for high net worth individuals and corporations."
  },
  {
    id: 4,
    title: "Contract Law",
    description: "Sophisticated contract drafting, negotiation, and dispute resolution services for high-value commercial agreements and complex transactions.",
    icon: "FileText",
    details: "We draft and negotiate contracts that provide certainty and protection while enabling our clients to achieve their commercial objectives."
  },
  {
    id: 5,
    title: "Corporate Governance",
    description: "Strategic advice on board matters, fiduciary duties, shareholder relations, and compliance with evolving regulatory frameworks.",
    icon: "Scale",
    details: "Our governance practice ensures our clients maintain the highest standards of corporate conduct and regulatory compliance."
  },
  {
    id: 6,
    title: "Arbitration",
    description: "Expert representation in international commercial arbitration and alternative dispute resolution.",
    icon: "Shield",
    details: "We provide sophisticated arbitration services and strategic counsel in complex cross-border disputes, with expertise in international arbitration institutions and procedures."
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "£450M Cross-Border Technology Acquisition",
    sector: "Technology",
    practiceArea: "Cross-border M&A",
    description: "Advised a European technology firm on the acquisition of a UK-based software company, navigating complex regulatory approvals across three jurisdictions.",
    outcome: "Successfully completed transaction within 6 months, securing all necessary regulatory clearances.",
    year: "2024"
  },
  {
    id: 2,
    title: "International Joint Venture Restructuring",
    sector: "Financial Services",
    practiceArea: "Corporate Law",
    description: "Represented a multinational financial institution in restructuring a complex international joint venture involving entities across London, Luxembourg, and Dubai.",
    outcome: "Delivered comprehensive restructuring solution that enhanced operational efficiency and governance.",
    year: "2023"
  },
  {
    id: 3,
    title: "Complex International Arbitration",
    sector: "Energy",
    practiceArea: "Arbitration",
    description: "Represented a multinational energy company in a complex ICC arbitration involving cross-border investment disputes.",
    outcome: "Achieved favourable arbitral award with full recovery of claimed damages.",
    year: "2024"
  },
  {
    id: 4,
    title: "Private Equity-Backed Management Buyout",
    sector: "Manufacturing",
    practiceArea: "Commercial Law",
    description: "Advised management team and private equity investors on £200M management buyout of a UK manufacturing business with international operations.",
    outcome: "Transaction completed successfully with optimized structure for future growth and value creation.",
    year: "2023"
  }
];

export const locations = [
  {
    id: 1,
    city: "London",
    country: "United Kingdom",
    address: "3rd Floor, 45 Albemarle Street, London W1S 4JL",
    phone: "+44 20 7123 4567",
    email: "contact@ashbournelaw.co.uk",
    isPrimary: true,
    description: "Our London Global Headquarters serves as the hub of our international practice, providing sophisticated legal services to domestic and international clients."
  },
  {
    id: 2,
    city: "Luxembourg",
    country: "Luxembourg",
    address: "European Hub (In Development)",
    phone: "+44 20 7123 4567",
    email: "contact@ashbournelaw.co.uk",
    isPrimary: false,
    description: "Our European hub providing connectivity for funds, private capital, and continental market development."
  },
  {
    id: 3,
    city: "Geneva",
    country: "Switzerland",
    address: "Switzerland Office (In Development)",
    phone: "+44 20 7123 4567",
    email: "contact@ashbournelaw.co.uk",
    isPrimary: false,
    description: "Serving Swiss and European clients with expertise in international corporate and commercial law."
  },
  {
    id: 4,
    city: "Dubai",
    country: "United Arab Emirates",
    address: "DIFC (Under Evaluation)",
    phone: "+44 20 7123 4567",
    email: "contact@ashbournelaw.co.uk",
    isPrimary: false,
    description: "Middle East hub under development, serving clients across the GCC region with sophisticated legal advice on complex international transactions."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Sir Michael Thornton QC",
    position: "Senior Partner",
    expertise: "Cross-border M&A, Corporate Law",
    bio: "Over 30 years of experience advising multinational corporations and high net worth individuals on complex international transactions.",
    education: "Oxford University (BA, BCL), Harvard Law School (LLM)"
  },
  {
    id: 2,
    name: "Victoria Ashbourne",
    position: "Managing Partner",
    expertise: "Commercial Law, Contract Law",
    bio: "Former general counsel of a FTSE 100 company with extensive experience in high-value commercial negotiations.",
    education: "Cambridge University (BA, LLM), London School of Economics"
  },
  {
    id: 3,
    name: "James Blackwell",
    position: "Partner",
    expertise: "Arbitration, International Disputes",
    bio: "Extensive experience representing clients in international commercial arbitration and cross-border disputes.",
    education: "LSE (LLB), Columbia Law School (LLM)"
  },
  {
    id: 4,
    name: "Sophia Chen",
    position: "Partner",
    expertise: "Corporate Governance, M&A",
    bio: "Specializes in Asian cross-border transactions with fluency in Mandarin and deep understanding of Asian business culture.",
    education: "National University of Singapore (LLB), Cambridge University (LLM)"
  }
];

export const testimonials = [
  {
    id: 1,
    client: "CEO, International Technology Group",
    quote: "Ashbourne Law provided exceptional guidance throughout our acquisition. Their cross-border expertise and attention to detail were invaluable.",
    rating: 5
  },
  {
    id: 2,
    client: "General Counsel, Global Financial Services Firm",
    quote: "The team's sophisticated approach to complex regulatory matters and their international reach make them our trusted advisors.",
    rating: 5
  },
  {
    id: 3,
    client: "Private Equity Managing Partner",
    quote: "Commercial acumen combined with legal excellence. Ashbourne Law understands business objectives and delivers pragmatic solutions.",
    rating: 5
  }
];

export const stats = [
  { label: "Years of Combined Board Experience", value: "30+" },
  { label: "International Clients", value: "200+" },
  { label: "Jurisdictions", value: "4", badge: "and expanding" },
  { label: "Success Rate", value: "98%" }
];

export const awards = [
  {
    id: 1,
    title: "Law Firm of the Year",
    organization: "The Lawyer Awards",
    year: "2024",
    status: "Winner",
    category: "Excellence"
  },
  {
    id: 2,
    title: "Best International Law Firm",
    organization: "Legal 500",
    year: "2024",
    status: "Winner",
    category: "International"
  },
  {
    id: 3,
    title: "M&A Team of the Year",
    organization: "Chambers Europe",
    year: "2024",
    status: "Finalist",
    category: "Practice Excellence"
  },
  {
    id: 4,
    title: "Corporate Governance Excellence",
    organization: "Financial Times",
    year: "2023",
    status: "Highly Commended",
    category: "Excellence"
  },
  {
    id: 5,
    title: "Innovation in Legal Services",
    organization: "Legal Business Awards",
    year: "2023",
    status: "Winner",
    category: "Innovation"
  },
  {
    id: 6,
    title: "Best Client Service",
    organization: "Citywealth",
    year: "2023",
    status: "Winner",
    category: "Client Focus"
  }
];

export const lawyers = [
  {
    id: 1,
    name: "Sir Michael Thornton QC",
    title: "Senior Partner",
    specializations: ["Cross-border M&A", "Corporate Law", "Private Equity"],
    location: "London",
    languages: ["English", "French"],
    email: "m.thornton@ashbournelaw.com",
    phone: "+44 20 7123 4501",
    bio: "Over 30 years of experience advising multinational corporations and high net worth individuals on complex international transactions.",
    education: "Oxford University (BA, BCL), Harvard Law School (LLM)",
    admissions: ["England & Wales"],
    experience: "32 years"
  },
  {
    id: 2,
    name: "Victoria Ashbourne",
    title: "Managing Partner",
    specializations: ["Commercial Law", "Contract Law", "Joint Ventures"],
    location: "London",
    languages: ["English", "German"],
    email: "v.ashbourne@ashbournelaw.com",
    phone: "+44 20 7123 4502",
    bio: "Former general counsel of a FTSE 100 company with extensive experience in high-value commercial negotiations.",
    education: "Cambridge University (BA, LLM), London School of Economics",
    admissions: ["England & Wales"],
    experience: "28 years"
  },
  {
    id: 3,
    name: "James Blackwell",
    title: "Partner",
    specializations: ["Arbitration", "International Disputes", "Commercial Litigation"],
    location: "London",
    languages: ["English"],
    email: "j.blackwell@ashbournelaw.com",
    phone: "+44 20 7123 4503",
    bio: "Extensive experience representing clients in international commercial arbitration and cross-border disputes with particular expertise in ICC and LCIA proceedings.",
    education: "LSE (LLB), Columbia Law School (LLM)",
    admissions: ["England & Wales"],
    experience: "25 years"
  },
  {
    id: 4,
    name: "Elena Rodriguez",
    title: "Partner",
    specializations: ["Real Estate", "Construction Law", "Property Finance"],
    location: "Dubai",
    languages: ["English", "Spanish", "Arabic"],
    email: "e.rodriguez@ashbournelaw.com",
    phone: "+971 4 123 4568",
    bio: "Leading expert in Middle East real estate transactions and construction disputes.",
    education: "University of Madrid (LLB), King's College London (LLM)",
    admissions: ["Spain", "DIFC"],
    experience: "22 years"
  }
];

export const sectors = [
  {
    id: 1,
    name: "Financial Services",
    icon: "Building2",
    description: "Comprehensive legal support for banks, investment firms, fintech companies, and financial institutions navigating complex regulatory environments.",
    expertise: ["Banking & Finance", "Investment Funds", "Fintech", "Regulatory Compliance", "Capital Markets"],
    keyClients: "Major banks, private equity firms, hedge funds"
  },
  {
    id: 2,
    name: "Technology & Software",
    icon: "Cpu",
    description: "Strategic counsel for technology companies, from startups to established enterprises, on transactions, IP protection, and regulatory matters.",
    expertise: ["Software Licensing", "Data Protection", "IP Strategy", "Tech M&A", "SaaS Agreements"],
    keyClients: "Tech startups, software companies, digital platforms"
  },
  {
    id: 3,
    name: "Private Equity",
    icon: "TrendingUp",
    description: "Expert guidance on fund formation, portfolio investments, exits, and complex restructurings for private equity sponsors and portfolio companies.",
    expertise: ["Fund Formation", "Deal Structuring", "Portfolio Management", "Exit Strategies", "Co-investments"],
    keyClients: "PE firms, venture capital, institutional investors"
  },
  {
    id: 4,
    name: "Real Estate",
    icon: "Home",
    description: "Full-service real estate legal advice covering acquisitions, developments, financing, and property disputes across multiple jurisdictions.",
    expertise: ["Property Acquisitions", "Development Projects", "Real Estate Finance", "Leasing", "Construction"],
    keyClients: "Developers, REITs, property investors"
  },
  {
    id: 5,
    name: "Healthcare & Life Sciences",
    icon: "HeartPulse",
    description: "Specialized legal services for pharmaceutical companies, medical device manufacturers, healthcare providers, and biotech firms.",
    expertise: ["Regulatory Affairs", "Clinical Trials", "IP & Patents", "Healthcare M&A", "Compliance"],
    keyClients: "Pharma companies, hospitals, biotech startups"
  },
  {
    id: 6,
    name: "Energy & Natural Resources",
    icon: "Zap",
    description: "Legal expertise in oil & gas, renewable energy, mining, and utilities, covering transactions, projects, and regulatory compliance.",
    expertise: ["Energy Projects", "Renewable Energy", "Mining Rights", "Environmental Law", "Joint Ventures"],
    keyClients: "Energy companies, utilities, mining corporations"
  },
  {
    id: 7,
    name: "Manufacturing & Industrials",
    icon: "Factory",
    description: "Legal support for manufacturing companies on supply chain, distribution, M&A, employment, and regulatory compliance matters.",
    expertise: ["Supply Chain", "Distribution Agreements", "Manufacturing M&A", "Employment", "Trade Compliance"],
    keyClients: "Manufacturers, industrial groups, automotive"
  },
  {
    id: 8,
    name: "Retail & Consumer Goods",
    icon: "ShoppingBag",
    description: "Comprehensive legal services for retailers and consumer brands covering commercial contracts, franchising, and brand protection.",
    expertise: ["Franchise Agreements", "Brand Protection", "Commercial Leases", "E-commerce", "Consumer Law"],
    keyClients: "Retail chains, consumer brands, e-commerce"
  }
];

export const faqs = [
  {
    id: 1,
    category: "Services",
    question: "What types of legal services does Ashbourne Law provide?",
    answer: "We provide comprehensive legal services across six core practice areas: Corporate Law, Commercial Law, Cross-border M&A, Contract Law, Corporate Governance, and Arbitration. Our services span multiple sectors and jurisdictions, with particular expertise in international transactions."
  },
  {
    id: 2,
    category: "Services",
    question: "Do you handle cross-border transactions?",
    answer: "Yes, cross-border transactions are one of our specialties. With our London headquarters and developing hubs in Luxembourg and Dubai, we have extensive experience managing complex multi-jurisdictional matters across Europe, the Middle East, and beyond."
  },
  {
    id: 3,
    category: "Engagement",
    question: "How do I engage your services?",
    answer: "Simply contact us through our website, email, or phone. We'll arrange a confidential initial consultation to discuss your legal needs and determine how we can best assist you. For urgent matters, we can typically arrange same-day or next-day consultations."
  },
  {
    id: 4,
    category: "Engagement",
    question: "What is your fee structure?",
    answer: "Our fee structures are tailored to each engagement and may include hourly rates, fixed fees, or alternative arrangements depending on the nature and scope of work. We provide transparent fee estimates upfront and can discuss flexible billing arrangements for appropriate matters."
  },
  {
    id: 5,
    category: "Engagement",
    question: "Do you work with international clients?",
    answer: "Absolutely. We regularly advise international corporations, financial institutions, and high net worth individuals from around the world. Our lawyers are qualified in multiple jurisdictions and fluent in various languages to better serve our global client base."
  },
  {
    id: 6,
    category: "Expertise",
    question: "What industries do you specialize in?",
    answer: "We have deep expertise across eight key sectors: Financial Services, Technology & Software, Private Equity, Real Estate, Healthcare & Life Sciences, Energy & Natural Resources, Manufacturing & Industrials, and Retail & Consumer Goods."
  },
  {
    id: 7,
    category: "Expertise",
    question: "What sets Ashbourne Law apart from other firms?",
    answer: "Our boutique structure combines the sophistication and expertise of a major international firm with the personalized service and agility of a smaller practice. Every matter is partner-led, ensuring senior-level attention throughout. We focus on commercially-driven solutions rather than purely legal analysis."
  },
  {
    id: 8,
    category: "Communication",
    question: "How quickly do you respond to client inquiries?",
    answer: "We aim to respond to all client inquiries within 24 hours during business days. For existing clients with urgent matters, we provide 24/7 emergency contact access to designated partners."
  },
  {
    id: 9,
    category: "Communication",
    question: "Can I meet with lawyers in person?",
    answer: "Yes, we welcome in-person meetings at our London headquarters. We also have developing hubs in Luxembourg and Dubai. For clients located elsewhere, we offer video conferencing for convenient remote consultations."
  },
  {
    id: 10,
    category: "Confidentiality",
    question: "How do you ensure client confidentiality?",
    answer: "Client confidentiality is paramount. We maintain strict information security protocols, including secure document management systems, encrypted communications, and comprehensive confidentiality agreements with all staff. We are bound by professional privilege and regulatory requirements to protect client information."
  }
];

export const careerOpportunities = [
  {
    id: 1,
    title: "Senior Associate - Corporate M&A",
    location: "London",
    type: "Full-time",
    experience: "5-8 years",
    description: "Join our growing M&A team to work on sophisticated cross-border transactions for corporate and private equity clients.",
    requirements: ["PQE 5-8 years", "Strong M&A experience", "Excellent client relationship skills", "Cross-border transaction experience preferred"]
  },
  {
    id: 2,
    title: "Partner - Arbitration",
    location: "London",
    type: "Partner",
    experience: "15+ years",
    description: "Seeking an experienced arbitration lawyer to expand our international disputes practice.",
    requirements: ["15+ years PQE", "Significant international arbitration experience", "Established client base", "England & Wales qualification"]
  },
  {
    id: 3,
    title: "Associate - Commercial Contracts",
    location: "Dubai",
    type: "Full-time",
    experience: "3-5 years",
    description: "Opportunity to work on complex commercial agreements for multinational corporations in the Middle East region.",
    requirements: ["PQE 3-5 years", "Commercial contracts experience", "DIFC or international qualification preferred", "Arabic language skills beneficial"]
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Navigating Cross-Border M&A in 2025: Key Regulatory Developments",
    slug: "navigating-cross-border-ma-2025",
    excerpt: "An analysis of the evolving regulatory landscape for international mergers and acquisitions, including new compliance requirements in major jurisdictions.",
    author: "Victoria Ashbourne",
    category: "M&A",
    date: "2025-01-15",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
    featured: true
  },
  {
    id: 2,
    title: "The Rise of ESG Considerations in Corporate Governance",
    slug: "esg-corporate-governance",
    excerpt: "How environmental, social, and governance factors are reshaping corporate decision-making and board responsibilities in the modern business landscape.",
    author: "Sir Michael Thornton QC",
    category: "Corporate Governance",
    date: "2025-01-10",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2"
  },
  {
    id: 3,
    title: "International Arbitration: Emerging Trends in Cross-Border Disputes",
    slug: "international-arbitration-trends",
    excerpt: "A comprehensive review of recent arbitration trends and best practices for managing complex international commercial disputes.",
    author: "James Blackwell",
    category: "Arbitration",
    date: "2025-01-05",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1587702068694-a909ef4aa346"
  },
  {
    id: 4,
    title: "Contract Law Updates: Implications for International Business",
    slug: "contract-law-updates-2025",
    excerpt: "Recent developments in contract law and their impact on cross-border commercial agreements and dispute resolution.",
    author: "Victoria Ashbourne",
    category: "Commercial Law",
    date: "2024-12-28",
    readTime: "7 min read",
    image: "https://images.pexels.com/photos/6077091/pexels-photo-6077091.jpeg"
  },
  {
    id: 5,
    title: "Artificial Intelligence and Corporate Legal Compliance",
    slug: "ai-corporate-compliance",
    excerpt: "Exploring the legal challenges and opportunities presented by AI adoption in corporate environments and emerging regulatory frameworks.",
    author: "Sophia Chen",
    category: "Technology & Law",
    date: "2024-12-20",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72"
  },
  {
    id: 6,
    title: "Private Equity Investments: Structuring for Success",
    slug: "private-equity-structuring",
    excerpt: "Best practices for structuring private equity investments with consideration for tax efficiency, governance, and exit strategies.",
    author: "Sir Michael Thornton QC",
    category: "M&A",
    date: "2024-12-15",
    readTime: "11 min read",
    image: "https://images.pexels.com/photos/9367109/pexels-photo-9367109.jpeg"
  }
];
